<template lang="pug">
modal#cancel-bulk-send-modal(
  :no-footer='true'
  :no-header='true'
  ref='modal'
  size='lg'
)
  .d-flex.align-items-start.gap-3
    span.cancel-icon.d-flex.align-items-center.justify-content-center.rounded-circle.flex-shrink-0
      icon(name='triangle-exclamation')
    .d-flex.flex-column.gap-1.flex-grow-1
      h2.cancel-title.m-0 {{ $t('bulkSendDetails.cancelBulkSend.title') }}
      p.cancel-description.m-0 {{ $t('bulkSendDetails.cancelBulkSend.description') }}
    button.cancel-close.btn.btn-link.p-0(
      :aria-label='$t("bulkSendDetails.cancelBulkSend.close")'
      @click='close'
      type='button'
    )
      icon(name='xmark')

  .cancel-box.rounded.overflow-hidden.mt-4
    .cancel-summary.d-flex.justify-content-between.align-items-center.px-3.py-2
      span {{ $t('bulkSendDetails.cancelBulkSend.willBeCancelled') }}
      span.cancel-summary__total {{ pending }}
    .cancel-signed.d-flex.justify-content-between.align-items-center.px-3.py-2
      span {{ $t('bulkSendDetails.cancelBulkSend.alreadySigned') }}
      span {{ completed }}

  .cancel-footer.d-flex.justify-content-end.gap-2.mt-4
    button.cancel-back.btn(@click='close' type='button')
      | {{ $t('bulkSendDetails.cancelBulkSend.back') }}
    button.cancel-confirm.btn.d-flex.align-items-center.gap-2(
      :disabled='loading'
      @click='confirm'
      type='button'
    )
      icon(name='ban')
      | {{ $t('bulkSendDetails.cancelBulkSend.confirm') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'CancelBulkSendModal',
  components: {
    Modal,
    Icon,
  },
  props: {
    pending: {
      type: Number,
      default: 0,
    },
    completed: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="stylus" scoped>
.cancel-icon
  width: 44px
  height: 44px
  background-color: #FBEAEA
  color: #B42318

.cancel-title
  font-size: 19px
  font-weight: 600
  color: #1F2D2C

.cancel-description
  font-size: 14px
  line-height: 1.55
  color: #3C4A49

.cancel-close
  color: #4F5C5B

.cancel-box
  border: 1px solid #F1D0CD

.cancel-summary
  font-size: 14px
  color: #9B1C1C
  background-color: #FDF3F2
  &__total
    font-size: 20px
    font-weight: 600

.cancel-signed
  font-size: 13px
  color: #3C4A49
  border-top: 1px solid #F1D0CD

.cancel-footer
  padding-top: 16px
  border-top: 1px solid #ECECEC

.cancel-back
  border: 1.5px solid #0E5F5A
  background-color: #FFFFFF
  color: #0E5F5A
  font-weight: 600
  &:hover
    background-color: #E6F1F0
    color: #0E5F5A

.cancel-confirm
  border: 0
  background-color: #B42318
  color: #FFFFFF
  font-weight: 500
  &:hover, &:disabled
    background-color: #912018
    color: #FFFFFF
</style>
